import script from "./FirmaDetayScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./FirmaDetayScreen.vue?vue&type=script&setup=true&lang=js"

import "./FirmaDetayScreen.vue?vue&type=style&index=0&id=7a923ecf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a923ecf"]])

export default __exports__